import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    MaterialReactTable,
    useMaterialReactTable
} from "material-react-table";
import { Box, Typography } from "@mui/material";

const TableViewAudiences = ({ setLoginStatus }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);


    const values = useCallback(async () => {

        const body = {
            account: { token: localStorage.token, email: localStorage.email }
        };

        setLoading(true);
        try {
            const response = await fetch("/audiences", {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });

            if (response.ok) {
                // Handle successful response (200-299 status codes)
                const d = await response.json();
                if (d && d.audiences) {
                    setData(d.audiences);
                }


            } else if (response.status === 401) {
                setLoginStatus({ auth: false, email: null, token: null });
            } else if (response.status === 404) {
                // Handle 404 Not Found error
                console.log("Resource not found.");
            } else if (response.status === 500) {
                // Handle 500 Internal Server Error
                console.log("Internal server error.");
            } else {
                // Handle other error statuses
                console.log("An error occurred:", response.status);
            }
        } catch (error) {
            // Handle network or other general errors
            console.log("An error occurred:", error);
        } finally {
            setLoading(false); // Hide spinner
        }

    }, []);

    useEffect(() => {
        values();
    }, []);


    const columns = useMemo(
        () => [
            {
                header: "Name",
                accessorKey: "name",
                size: 500,
                minSize: 20,
                maxSize: 800
            },
            {
                header: "Type",
                accessorKey: "type"
            },
            {
                header: "Status",
                accessorKey: "status"
            },
            {
                header: "Platform",
                accessorKey: "platform"
                /*size: 150,
                minSize: 20,
                maxSize: 400,*/
            },
            {
                header: "Platform ID",
                accessorKey: "platformId"
            },
            {
                header: "Scope",
                accessorKey: "locationType"
                /*size: 160,
                minSize: 20,
                maxSize: 400,*/
            },
            {
                header: "Location",
                accessorKey: "location"
                /*size: 150,
                minSize: 20,
                maxSize: 400,*/
            },
            {
                header: "Date",
                accessorKey: "date"
                /*size: 80,
                minSize: 20,
                maxSize: 400,*/
            }
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data,
        state: { isLoading: loading },
        muiSkeletonProps: {
            animation: "wave"
        },
        muiLinearProgressProps: {
            color: "secondary"
        },
        muiCircularProgressProps: {
            color: "secondary"
        },
        /*displayColumnDefOptions: {
          'mrt-row-expand': {
            enableResizing: true,
          },
        },*/
        enableColumnDragging: false,
        enableColumnResizing: true,
        muiDetailPanelProps: () => ({
            sx: (theme) => ({
                backgroundColor:
                    theme.palette.mode === "dark"
                        ? "rgba(255,210,244,0.1)"
                        : "rgba(0,0,0,0.1)"
            })
        }),
        //enableGrouping: true,
        //enableStickyHeader: true,
        //enableStickyFooter: true,
        initialState: {
            columnVisibility: { platformId: false, status: false, type: false }, //hide firstName column by default
            density: "compact",
            expanded: true, //expand all groups by default
            //grouping: [], //an array of columns to group by by default (can be multiple)
            pagination: { pageIndex: 0, pageSize: 10 },
            sorting: [{ id: "date", desc: true }] //sort by state by default
        },
        paginateExpandedRows: false,
        muiToolbarAlertBannerChipProps: { color: "primary" },
        renderDetailPanel: ({ row }) =>
            (
                <Box
                    sx={{
                        display: "grid",
                        margin: "auto",
                        gridTemplateColumns: "400px 1fr",
                        width: "100%"
                    }}
                >
                    {/*
          //sx={{backgroundColor: row.original.status === 'Approved' ? '#00a950' : row.original.status === 'Denied' ? '#a90000' : ''  }}
*/}
                    <Typography sx={{
                        fontWeight: "bold"
                    }}>Status: <Box
                        component="span"
                        sx={{
                            fontWeight: "bold",
                            backgroundColor: row.original.platform !== "The Trade Desk" && row.original.platform !== "DV360" && row.original.platform !== "Yahoo" ? "" : row.original.status === "Approved" ? "#00a950" : row.original.status === "Denied" ? "#a90000" : row.original.status === "Pending" || row.original.status === "Resubmitted" ? "#f0ad4e" : "", // Replace with your desired color
                            color: "white", // Optional: change text color for better contrast
                            borderRadius: "4px",
                            padding: "2px 6px"
                        }}
                    > {row.original.platform === "The Trade Desk" || row.original.platform === "DV360" || row.original.platform === "Yahoo" ? row.original.status : "-"} </Box>
                    </Typography>
                    <Typography><Box component="span" sx={{ fontWeight: "bold" }}>Audience Name: </Box> <Box
                        component="span"
                        sx={{ backgroundColor: row.original.status === "Denied" || !row.original.profileName || row.original.profileName?.substring(row.original.profileName?.indexOf(" - ") + 3)?.trim() === row.original.name?.trim() ? "" : "#00A95059" }}> {!row.original.profileName || row.original.status === "Denied" ? "-" : row.original.profileName}</Box></Typography>
                    <Typography><Box component="span" sx={{ fontWeight: "bold" }}>Type:</Box> {row.original.type}
                    </Typography>
                    <Typography><Box component="span" sx={{ fontWeight: "bold" }}>Audience
                        ID: </Box> {!row.original.profileName || row.original.status === "Denied" ? "-" : row.original.profileId}
                    </Typography>
                    <Typography><Box component="span" sx={{ fontWeight: "bold" }}>Submitted Platform
                        ID:</Box> {row.original.platformId}</Typography>
                    <Typography><Box component="span" sx={{ fontWeight: "bold" }}>Live Platform
                        ID:</Box> {!row.original.profileName || row.original.status === "Denied" ? "-" : row.original.profilePlatformId}
                    </Typography>
                    <Typography><Box component="span" sx={{ fontWeight: "bold" }}>Active
                        Count:</Box> {row.original.active && row.original.status === "Approved" ? Number(row.original.active).toLocaleString() : "-"}
                    </Typography>
                </Box>
            )
        //muiTableContainerProps: { sx: { maxHeight: 700 } },
    });

    return <MaterialReactTable table={table} />;
};

export default TableViewAudiences;